// index.tsx (UI-only)
import React from 'react'
import { Button } from 'antd'
import {
  Container,
  LoginBox,
  LogoWrapper,
  Logo,
  LoginDetails,
  Label,
  InputWrapper,
  ErrorWrapper,
  ButtonWrapper,
  StyledInput,
} from './index.styled'
import { ErrorStatus, useScanLogin } from './useScanLogin'
import LogoBadgeOutlined from '../../../images/LogoBadgeOutlined.png'

export default function AuthScan() {
  const { code, error, buttonLoading, errorStatus, handleChange, getStudio } = useScanLogin()

  return (
    <Container>
      <LoginBox>
        <LogoWrapper>
          <Logo src={LogoBadgeOutlined} />
        </LogoWrapper>

        <LoginDetails
          onKeyDown={(e) => {
            if (e.key === 'Enter') getStudio()
          }}
        >
          <InputWrapper>
            <Label>Studio Code</Label>

            <StyledInput
              value={code}
              inputMode="numeric"
              onChange={(e) => handleChange(e.target.value)}
              status={errorStatus}
              placeholder="Enter Code"
            />

            {error === 'empty' && <ErrorWrapper>Please enter studio code !</ErrorWrapper>}
            {error === 'no_clinic' && <ErrorWrapper>Studio not found !</ErrorWrapper>}

            <ButtonWrapper>
              <Button type="primary" loading={buttonLoading} onClick={getStudio} style={{ width: '100%' }}>
                {buttonLoading ? '' : 'Set Up'}
              </Button>
            </ButtonWrapper>
          </InputWrapper>
        </LoginDetails>
      </LoginBox>
    </Container>
  )
}
